/**
 * Application configuration
 * Centralized configuration for API, Mock mode, etc.
 */

export const IS_MOCK = false; // Set to false to use real API
export const MOCK_DELAY = 1000; // Mock data delay in milliseconds
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5163/api/v1';
// export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://uat-api.mispy.ai/api/v1';
// Environment
export const APP_ENV = import.meta.env.MODE.toLowerCase();
export const IS_DEVELOPMENT = import.meta.env.DEV;
export const IS_UAT_ENV = APP_ENV === 'uat';
export const IS_PRODUCTION_ENV = APP_ENV === 'production';
